import {FC, memo, PropsWithChildren} from "react";
import './GridAreaContentLayout.css'
import classnames from "classnames";
import useIsMobile from "../../hooks/useIsMobile";

type GridAreaContentLayoutProps = PropsWithChildren<{
  fullHeight?: boolean,
  compact?: boolean,
  contentNoVerticalPadding?: boolean,
  heading?: string | React.ReactNode,
  footer?: React.ReactNode,
}>

const GridAreaContentLayoutComponent: FC = ({
  fullHeight = false,
  compact = false,
  contentNoVerticalPadding = false,
  heading,
  footer,
  // @ts-ignore
  children,
}: GridAreaContentLayoutProps) => {

  const isMobile = useIsMobile()

  return (

    <div className={classnames("grid-area-layout-container", {
      "compact": compact || isMobile,
    })}>
      <div className={classnames("grid-area-layout-content-wrapper", {
        "full-height": fullHeight || isMobile,
        "compact": compact || isMobile,
      })}>
        { heading && <div className={classnames("grid-area-layout-heading", { "compact": compact || isMobile })}>{heading}</div>}
        { children && <div className={classnames("grid-area-layout-content", { "compact": compact || isMobile, "no-vertical-padding": contentNoVerticalPadding })}>{children}</div> }
        { footer && <div className={classnames("grid-area-layout-footer", { "compact": compact || isMobile , })}>{footer}</div> }
      </div>
    </div>
  )
}

export const GridAreaContentLayout = memo<GridAreaContentLayoutProps>(GridAreaContentLayoutComponent)